import React from "react";
import { Link } from "react-router-dom";
import "../components/about.css";
import CTA from "../components/cta";
function Leasing()
{
    return(
       <>
    <section
           className="flat-title-page innerbanner mrg-0 boder-r-0 pdg-btm-60"
           style={{ backgroundImage: "url(images/inner-banner/leasing.jpg)" }}
         >
           <div className="container">
             <div className="breadcrumb-content">
               <h1 className="text-center text-white title">Leasing</h1>
               <ul className="breadcrumb">
                 <li>
                   <Link to="/" className="text-white">
                     Home
                   </Link>
                 </li>
                 <li className="text-white">/ Services</li>
                 <li className="text-white">/ Leasing</li>
               </ul>
             </div>
           </div>
         </section> 
  <section className="flat-section agnts">
    <div className="container">
      <div className="flat-img-with-text">
        <div className="content-left img-animation wow">
          <img
            className="lazyload"
            src="assets/images/tyrew.webp"
            alt=""
            style={{ borderRadius: 10 }}
          />
        </div>
        <div className="content-right">
          <div className="box-title wow fadeInUp">
            <div className="text-subtitle text-primary">Services</div>
            <h3 className="title mt-4">
              {" "}
              Premier Property Leasing Services UAE – Nova Vision Real Estate
            </h3>
            <p className="desc">
              Searching for the best Property Leasing services UAE has to offer
              is the first step toward a successful investment. Nova Vision Real
              Estate helps owners turn empty units into stable and predictable
              income streams. We make the entire leasing process simple, safe,
              and stress-free for every landlord in the market.
            </p>
            <h3 className="title mt-4">
              Why Choose Nova Vision for Your Property Needs
            </h3>
            <p className="desc">
              Our experienced team uses deep market knowledge to find the right
              tenants for your specific property. We handle professional
              marketing and photography to ensure your unit never stays empty
              for long. Better tenant screening means lower risks and fewer
              payment delays for your peace of mind. <br />
              Our comprehensive services include:
            </p>
            <br />
            <ul>
              <li>
                • Tenant Sourcing: We find high-quality tenants using major UAE
                property portals and our network.
              </li>
              <li>
                • Legal Protection: Our experts draft RERA-compliant contracts
                and handle mandatory Ejari registration.
              </li>
              <li>
                • Rent Management: We collect payments on time and track every
                lease renewal automatically.
              </li>
              <li>
                • Maintenance Care: We coordinate all repairs to keep your
                valuable asset in top condition.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="flat-section agnts">
    <div className="container">
      <div className="flat-img-with-text">
        <div className="content-right">
          <div className="box-title wow fadeInUp">
            <h3 className="title mt-4">
              Expert Management for Residential and Commercial Units
            </h3>
            <p className="desc">
              We manage everything from luxury waterfront villas to large office
              spaces in busy business districts. Our residential services focus
              on high tenant retention and creating comfortable homes for
              families. For business owners, we provide compliant commercial
              leases and thorough technical due diligence.
            </p>
            <h3 className="title mt-4">
              Your Trusted Partner in UAE Real Estate Compliance
            </h3>
            <p className="desc">
              Trust is built on strictly following the laws set by RERA and the
              Dubai Land Department. We ensure every lease follows Law No. 26 of
              2007 to fully protect your legal rights. Our team stays updated on
              the latest 2026 market trends and new government regulations.
              <br />
              <br />
              Let Nova Vision handle the hard work while you enjoy the financial
              rewards of your investment. Contact us today to experience the
              premier Property Leasing services UAE landlords trust.
            </p>
          </div>
        </div>
        <div className="content-left img-animation wow">
          <img
            className="lazyload"
            src="assets/images/hiug.webp"
            alt=""
            style={{ borderRadius: 10 }}
          />
        </div>
      </div>
    </div>
  </section>
  <CTA/>
</>

    )
}
    export default Leasing;